import React from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { prefixLegend, suffixLegend } from '../../scripts/name.legend.script';

export interface AppLegendProps {
  component?: string,
  attribute: {check: boolean, name: string, index: number | string | null, sub_index: number | string | null},
  container: {valid: boolean, required: boolean, identical: boolean, exists: boolean}
};

const AppLegend: React.FunctionComponent<AppLegendProps> = ({component, attribute, container}) => {
  const {lang} = StateLanguage()

  return (
    <>
      { container.valid &&
        <div id={`${prefixLegend(component)}legend-${attribute.name}-valid${suffixLegend(attribute.index, attribute.sub_index)}`} className="fv-plugins-message-container invalid-feedback d-none">
          <div data-field={attribute.name} data-validator="regexp">{attribute.sub_index === null ? lang.labels.theValueIsNotAValid : lang.labels.invalid}</div>
        </div>
      }
      { container.required &&
        <div id={`${prefixLegend(component)}legend-${attribute.name}-required${suffixLegend(attribute.index, attribute.sub_index)}`} className="fv-plugins-message-container invalid-feedback d-none">
          <div data-field={attribute.name} data-validator="notEmpty">{attribute.sub_index === null ? lang.labels.theValueIsRequired : lang.labels.required}</div>
        </div>
      }
      { container.identical &&
        <div id={`${prefixLegend(component)}legend-${attribute.name}-identical${suffixLegend(attribute.index, attribute.sub_index)}`} className="fv-plugins-message-container invalid-feedback d-none">
          <div data-field={attribute.name} data-validator="identical">{lang.labels.theValueDoesNotMatch}</div>
        </div>
      }
      { container.exists &&
        <div id={`${prefixLegend(component)}legend-${attribute.name}-exists${suffixLegend(attribute.index, attribute.sub_index)}`} className="fv-plugins-message-container invalid-feedback d-none">
          <div data-field={attribute.name} data-validator="exists">{lang.labels.theValueAlreadyExists}</div>
        </div>
      }
    </>
  )
}

export default AppLegend;
